import { z } from 'zod'

/** A test-mail allowlist entry is one address or a whole domain (mirrors Prisma `AllowlistEntryKind`). */
export const ALLOWLIST_ENTRY_KINDS = ['address', 'domain'] as const

export const allowlistEntryKindSchema = z.enum(ALLOWLIST_ENTRY_KINDS)

export type AllowlistEntryKind = z.infer<typeof allowlistEntryKindSchema>

export const PRISMA_ALLOWLIST_ENTRY_KINDS = ['ADDRESS', 'DOMAIN'] as const

export type PrismaAllowlistEntryKind = (typeof PRISMA_ALLOWLIST_ENTRY_KINDS)[number]

export const ALLOWLIST_ENTRY_KIND_FROM_PRISMA = {
  ADDRESS: 'address',
  DOMAIN: 'domain',
} as const satisfies Record<PrismaAllowlistEntryKind, AllowlistEntryKind>

export const ALLOWLIST_ENTRY_KIND_TO_PRISMA = {
  address: 'ADDRESS',
  domain: 'DOMAIN',
} as const satisfies Record<AllowlistEntryKind, PrismaAllowlistEntryKind>

/** Pending until confirmed (address) or found in DNS (domain); mirrors Prisma `AllowlistEntryStatus`. */
export const ALLOWLIST_ENTRY_STATUSES = ['pending', 'active'] as const

export const allowlistEntryStatusSchema = z.enum(ALLOWLIST_ENTRY_STATUSES)

export type AllowlistEntryStatus = z.infer<typeof allowlistEntryStatusSchema>

export const PRISMA_ALLOWLIST_ENTRY_STATUSES = ['PENDING', 'ACTIVE'] as const

export type PrismaAllowlistEntryStatus = (typeof PRISMA_ALLOWLIST_ENTRY_STATUSES)[number]

export const ALLOWLIST_ENTRY_STATUS_FROM_PRISMA = {
  PENDING: 'pending',
  ACTIVE: 'active',
} as const satisfies Record<PrismaAllowlistEntryStatus, AllowlistEntryStatus>

export const ALLOWLIST_ENTRY_STATUS_TO_PRISMA = {
  pending: 'PENDING',
  active: 'ACTIVE',
} as const satisfies Record<AllowlistEntryStatus, PrismaAllowlistEntryStatus>
